module.exports = __webpack_public_path__ + "img/icon_sustainable.7add06f.svg";